import React, { useState } from 'react';
import { CardContent, Typography, Card } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AreaChart, Area, ResponsiveContainer } from 'recharts';
import CardModal from './CardModal';
import { _trimFuturePeriods, getPreviousMonthsData, getPreviousYearData, getValueFromDotSeparatedKey } from '../utils';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  card: {
    flex: 1,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
      marginTop: -3,
    },
  },
  cardContent: {
    minHeight: '200px',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  headerText: {
    color: '#363347',
    lineHeight: '20px',
  },
  subHeaderText: {
    padding: '0.5rem 0',
    borderBottom: '1px solid lightgrey',
    fontSize: '14px',
    color: '#5C6178',
    fontWeight: 500,
  },
  contentContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginTop: '.5rem',
    minHeight: 85
  },
  countText: {
    fontSize: '38px',
    fontWeight: 600,
  },
  secondaryStat:{
    fontSize:'14px',
    fontWeight:500,
    marginTop:'-30px',
    marginBottom:7
  },
  secondaryText:{
    fontSize:'12px',
    fontWeight:300
  },
  percentageText: {
    fontSize: '14px',
    color: '#171F26',
  },
  positivePercentage: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#84EAB3',
  },
  negativePercentage: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#FF206E',
  },
}));

export default function MarketCard({
  cardListViewData,
  eventType,
  startDate,
  endDate,
  chartType,
  chartView,
  isWeekly,
  title,
  subTitle,
  fetchInProgress,
  type,
  statKey,
  formatter,
  returnData,
  cardIndex,
  idx,
  snapshotTitle,
  fq,
  activityType,
  stat,
  statsMode,
}) {
  const classes = useStyles();
  cardListViewData = _trimFuturePeriods(cardListViewData);





  const formatTime = (data, simple) => {
    let month = data && data.val;
    if (month) {
      const date = new Date(month);
      const monthName = simple
        ? date.toLocaleString('default', { month: 'short', timeZone: 'UTC' })
        : date.toLocaleString('default', { month: 'long', timeZone: 'UTC' });
      const year = date.getUTCFullYear();
      if (isWeekly === '+7DAY') {
        const day = date.getDate();
        if (simple) {
          return `${monthName} ${day}, ${year}`;
        } else {
          return `Week of ${monthName} ${day}, ${year}`;
        }
      } else if (isWeekly === '+1MONTH') {
        return `${monthName} ${year}`;
      } else if (isWeekly === '+3MONTH') {
        const month = date.getUTCMonth(); // Get the month (0-11)
        const year = date.getUTCFullYear(); // Get the full year
        // Determine the quarter based on the month
        let quarter;
        if (month >= 0 && month <= 2) {
          quarter = 'Q1';
        } else if (month >= 3 && month <= 5) {
          quarter = 'Q2';
        } else if (month >= 6 && month <= 8) {
          quarter = 'Q3';
        } else {
          quarter = 'Q4';
        }
        return `${quarter} ${year}`;
      } else if (isWeekly === '+1YEAR'){
        return `${year}`;
      } else if (data && endDate) {
        if(simple){
          const day = date.getDate();
          return `${monthName} ${day}, ${year}`;
        }
        return `${moment(startDate).format("ll")} - ${moment(endDate).format("ll")}`;
      }
    }  else {
      return '';
    }
  };


  const getPercentage = (val1, val2) => {
    if (val1 && val2) {
      const newCount = val1;
      const oldCount = val2;
      const percentageChange = ((newCount - oldCount) / oldCount) * 100;
      return `${percentageChange > 0 ? '+' : ''}${percentageChange.toFixed(2)}%`;
    } else {
      return '';
    }
  };

  const monthlyData = getPreviousMonthsData(cardListViewData);
  const yearlyData = getPreviousYearData(
    cardListViewData,  monthlyData && monthlyData[1] && monthlyData[1].val && monthlyData[1].val,
    isWeekly
  );
  console.log(yearlyData)
  const keyStat =
    monthlyData &&
    monthlyData[1] &&
    monthlyData[1][type.key] &&
    getValueFromDotSeparatedKey(monthlyData[1][type.key], statKey)
      ? formatter(getValueFromDotSeparatedKey(monthlyData[1][type.key], statKey))
      : '--';
      
  const secondaryStat = stat.secondaryKey &&
    monthlyData &&
    monthlyData[1] &&
    monthlyData[1][type.key] &&
    getValueFromDotSeparatedKey(monthlyData[1][type.key], stat.secondaryKey)
      ? formatter(getValueFromDotSeparatedKey(monthlyData[1][type.key], stat.secondaryKey))
      : false;
    
  const newVal = monthlyData && monthlyData[1] && monthlyData[1][type.key]
    ? getValueFromDotSeparatedKey(monthlyData[1][type.key], statKey)
    : false;
  const oldVal = monthlyData && monthlyData[0] && monthlyData[0][type.key]
    ? getValueFromDotSeparatedKey(monthlyData[0][type.key], statKey)
    : false;
  const yearVal = yearlyData && yearlyData[type.key]
    ? getValueFromDotSeparatedKey(yearlyData[type.key], statKey)
    : false;
    
  console.log(yearVal)
  const data = cardListViewData.slice(isWeekly !== '+1MONTH' ? -53 : 0).map((item) => {
    return {
      name: item.val,
      val: item.val,
      value: item[type.key] && getValueFromDotSeparatedKey(item[type.key], statKey)
        ? getValueFromDotSeparatedKey(item[type.key], statKey)
        : 0,
    };
  });

  if (returnData) {
    return { stat: keyStat };
  }

  const [isOpen, setIsOpen] = useState(null);
  const toggleModal = () => setIsOpen(null);

  const getComparisonText = () => {
    if (isWeekly === '+7DAY') return 'vs. prior week';
    if (isWeekly === '+1MONTH') return 'vs. prior month';
    if (isWeekly === '+3MONTH') return 'vs. prior quarter';
    return 'vs. prior period';
  };

  const ChartContainer=()=>{
    return <> <ResponsiveContainer>
    <AreaChart
      data={data}
      margin={{
        top: 0,
        right: 0,
        left: -15,
        bottom: 0,
      }}
    >
      <Area type="monotone" dataKey="value" stroke={`${type.checkedColor}`} fill={`${type.checkedColor}`} fillOpacity={0.2} />
    </AreaChart>
  </ResponsiveContainer>
  {data && data.length > 1 && (
    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 10 }}>
      <div>{formatTime(data && data[0] ? data[0] : false, true)}</div>
      <div>{formatTime(data && data[data.length - 1] ? data[data.length - 1] : false, true)}</div>
    </div>
  )}</>
  }
  return (
    <>
      <Card
        className={classes.card}
        style={{ borderTop: `1px solid ${type.checkedColor}`, borderBottom: `5px solid ${type.checkedColor}` }}
        onClick={() => {
          if (`${type.name}-${idx}` === cardIndex) {
            setIsOpen(cardIndex);
          }
        }}
      >
        <CardContent className={classes.cardContent}>
          <Typography component="div">
            <Typography variant="h5" component="div" className={classes.headerText}>
              {title}
            </Typography>
            <Typography variant="h6" component="div" className={classes.subHeaderText}>
              {!fetchInProgress
                ? `${subTitle} ${formatTime(monthlyData && monthlyData[1] ? monthlyData[1] : false)}`
                : `${subTitle} ....`}
            </Typography>
            {!fetchInProgress ? (
              <Typography component="div" className={classes.contentContainer}>
                <Typography component="div">
                  <Typography variant="h6" component="div" className={`${classes.countText} key-stat`}>
                    {keyStat}
                  </Typography>
                </Typography>
                
                <Typography component="div">
                  <Typography variant="h5" component="span" className={classes.percentageText}>
                    {getComparisonText()}
                  </Typography>
                  <Typography
                    variant="h6"
                    component="div"
                    className={
                      getPercentage(newVal, oldVal).includes('-') ? classes.negativePercentage : classes.positivePercentage
                    }
                  >
                    {getPercentage(newVal, oldVal)}
                  </Typography>
                  {["+7DAY", "+1MONTH", "+3MONTH"].indexOf(isWeekly)>-1 ?
                    <>
                    <Typography variant="h5" component="span" className={classes.percentageText}>
                      vs. prior year
                    </Typography>
                    <Typography variant="h6" component="div" className={getPercentage(newVal, yearVal).includes("-") ? classes.negativePercentage : classes.positivePercentage}>
                      {getPercentage(newVal, yearVal)}
                    </Typography>
                  </> : null}
                </Typography>
                
                
              </Typography>
              
            ) : null}
            {secondaryStat ? (
              <Typography component="div">
                <Typography variant="h6" component="div" className={`${classes.secondaryStat} secondary-stat`}>
                  {secondaryStat} {stat.secondaryTitle ? <span className={`${classes.secondaryText}`}>{stat.secondaryTitle}</span> : null}
                </Typography>
              </Typography>
              
            ) : null}
            <div style={{ height: 60, width: '100%' }}>
             <ChartContainer/>
            </div>
          </Typography>
        </CardContent>
      </Card>
      {isOpen && (
        <CardModal
          isOpen={isOpen}
          chartType={chartType}
          chartView={chartView}
          toggleModal={toggleModal}
          eventType={eventType}
          eventName={type.key}
          startDate={startDate}
          endDate={endDate}
          monthlyData={monthlyData}
          isWeekly={isWeekly}
          snapshotTitle={snapshotTitle}
          fq={fq}
          type={type}
          activityType={activityType}
          chartData={data}
          color={type.checkedColor}
          keyStat={keyStat}
          stat={stat}
          statsMode={statsMode}
        />
      )}
    </>
  );
}
